import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LegalDocumentsBloc } from '@kp/legal-document/legal-documents.bloc';
import { OnboardingBloc } from '@kp/onboarding/onboarding.bloc';
import { WorkbookBloc } from '@kp/workbook/workbook.bloc';
import { DataStoreService } from '@kservice';
import { EligibilityVerificationType, UserType } from '@ktypes/enums';
import { Status } from '@ktypes/models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'kp-eligibility',
  templateUrl: './eligibility.component.html',
  styleUrls: ['./eligibility.component.scss'],
})
export class EligibilityComponent implements OnInit, OnDestroy {
  @Input() eligibilityType: EligibilityVerificationType;
  eligibilityVerificationType = EligibilityVerificationType;
  error = false;
  isSingleValueEligibilityType: boolean;
  loading = false;

  private _destroy$ = new Subject<void>();

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _dataStoreService: DataStoreService,
    private _deviceDetectorService: DeviceDetectorService,
    private _legalDocumentsBloc: LegalDocumentsBloc,
    private _onboardingBloc: OnboardingBloc,
    private _router: Router,
    private _workbookBloc: WorkbookBloc
  ) {}

  ngOnInit(): void {
    this.isSingleValueEligibilityType = [
      EligibilityVerificationType.email,
      EligibilityVerificationType.member_identifier,
      EligibilityVerificationType.employee_identifier,
      EligibilityVerificationType.student_email,
      EligibilityVerificationType.student_identifier,
    ].includes(this.eligibilityType);
    this._onboardingBloc.eligibilityCandidateStatus$.pipe(takeUntil(this._destroy$)).subscribe((candidateStatus) => {
      if (candidateStatus?.status === Status.done) {
        const candidate = candidateStatus.data;
        if (candidate?.userType === UserType.user) {
          void this._router.navigate(['/login/existing_account']);
        } else if (candidate?.candidateId) {
          if (this._dataStoreService.authData.user.type === UserType.pulse) {
            this._onboardingBloc.setLatestPage('/privacy-pledge');
          } else {
            this._onboardingBloc.setLatestPage('/welcome/notice');
          }
          this._legalDocumentsBloc.fetchLegalDocuments();
          this._workbookBloc.updateCandidate(candidate);
          void this._router.navigate(
            [
              this._deviceDetectorService.isDesktop()
                ? '/welcome/mobile-app/interstitial'
                : '/welcome/mobile-app/interstitial/mobile',
            ],
            {
              queryParams: {
                verificationLink: candidate.eligibilityLink ?? '',
                showWorkbookModal: true,
              },
              replaceUrl: true,
            }
          );
        } else {
          this.error = true;
        }
        this.loading = false;
      }
      this.loading = false;
    });
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
